module.exports = __webpack_public_path__ + "static/media/icon-client-unread-message.d2d16c49.svg";